module.exports = __webpack_public_path__ + "media/images/front/responsive/institution-detail-rich/results01_sp-b5c321d933e7c43004d970f4d450a960.png";